import { render, staticRenderFns } from "./ComponentsSidebar.vue?vue&type=template&id=44e5560e&scoped=true&"
import script from "./ComponentsSidebar.vue?vue&type=script&lang=js&"
export * from "./ComponentsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsSidebar.vue?vue&type=style&index=0&id=44e5560e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5560e",
  null
  
)

export default component.exports